import type { ApprovalChain } from '../approval-chain.model';

export const DEED_ESTATE_TRANSFER_CHAIN: ApprovalChain = {
  id: 'deed-estate-transfer',
  label: 'Estate',
  applicationTypes: ['DEED_ESTATE_TRANSFER'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
